// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"comp_Wrapper__3lwhZ","center":"comp_center__1Otc4"};